import { Card, ListGroup } from 'react-bootstrap'
import experience from '../../data/experience.json'
import { useEffect, useState } from 'react'

export default function Experience(){
    const [myExperience, setMyExperience] = useState([]);

    useEffect(() =>{
        setMyExperience([...experience]);
    }, []);

    return (
        <section id="experience" className="about--section">
            <div>
                <h2 className='section-heading'>Experience</h2>
                <div>
                    <div className="header-bar"></div>
                </div>
            </div>
            <div className="experience-block">
                {
                    myExperience.map((exp) => {
                        return (<Card key={exp.id}>
                                    <Card.Header>{exp.period}</Card.Header>
                                    <Card.Body>
                                        <Card.Title><strong>{exp.designation}</strong></Card.Title>
                                        <Card.Subtitle className="mb-3 text-muted">{exp.company}</Card.Subtitle>
                                        <ListGroup variant="flush">
                                            {
                                                exp.responsibilities.map((res) =>{
                                                    return <ListGroup.Item key={res.id}>{res.desc}</ListGroup.Item>
                                                })
                                            }
                                        </ListGroup>
                                    </Card.Body>
                                </Card>)
                    })
                }
            </div>
        </section>
    )
}
